{
	"labels": {
		"skeniraj":"Poskenirajte spodnjo kodo z vašim avtentikatorjem:",
		"vnesiKodo": "Vnesite kodo zgenerirano v avtentikatorju",
		"prepisi": "Prepišite kodo v avtentikator:",
		"kodaNiVidna": "Če kode ne vidite, kliknite tukaj, za prikaz kode",
		"skrij": "Skrij kodo",
		"nastavljeno": "Ta račun že ima nastavljeno 2FA",
		"niNastavljeno": "Za ta račun 2FA še ni nastavljeno",
		"buttons": {
			"odpri": "Vklopi / izklopi 2FA",
			"vklopi": "vklopi dvostopenjsko preverjanje",
			"izklopi": "izklopi dvostopenjsko preverjanje",
			"ponastavi": "Ponastavi avtentikator",
			"generiranje": "Poteka aktivacija",
			"deaktivacija": "Poteka deaktivacija",
			"ponastavljanje": "Poteka ponastavljanje",
			"potrdiKodo": "Potrdi kodo"
		}
	},
	"obvestila": {
		"napakaBranja": "Napaka pri branju podatkov.",
		"napakaInputa": "Polje s kodo ne sme biti prazno!",
		"vprasanjeIzklopa": "Ali res želite izklopiti 2FA?",
		"izklopUspesen": "2FA uspešno izklopljena.",
		"vklopUspesen": "2FA uspešno nastavljen.",
		"niUjemanja": "Vnesena koda se ne ujema. Preverite vneseno kodo in poskusite znova!"
	}
}